import axios from '@/utils/axios';
import { ip3 } from '@/utils/constants';
import { IQuiDoi } from '@/services/QuyDoi/index';

export async function getQuyDoi(payload: {
  page: number;
  limit: number;
  cond?: any;
  donViId?: string;
}) {
  const { page, limit, cond } = payload;
  return axios.get(`${ip3}/quy-doi/pageable`, {
    params: {
      page,
      limit,
      donViId: payload.donViId,
      cond: {
        ...cond,
      },
    },
  });
}
export async function getQuyDoiThucPham(tenThucPham: string, donViId?: string) {
  return axios.get(`${ip3}/quy-doi/thuc-pham`, {
    params: {
      tenThucPham: tenThucPham,
      donViId: donViId,
    },
  });
}
export async function getListThucPham(donViId?: string) {
  return axios.get(`${ip3}/quy-doi/thuc-pham/don-vi/${donViId}`, );
}
export async function deleteQuyDoi(id: string) {
  return axios.delete(`${ip3}/quy-doi/${id}`);
}
export async function updateQuyDoi(data: IQuiDoi.DataUpdate) {
  return axios.put(`${ip3}/quy-doi/${data.id}`, data)
}
export async function createQuyDoi(data: IQuiDoi.DataCreate) {
  return axios.post(`${ip3}/quy-doi`, data);
}
export async function importQuyDoi(payload: any) {
  const file = payload?.file?.fileList?.[0].originFileObj;
  const form = new FormData();
  form.append('file', file);
  // const vaiTro = localStorage.getItem('vaiTro');
  // form.append('datatype', vaiTro === 'SuperAdmin' || vaiTro === 'Admin' ? 'Hệ thống' : 'Khác');
  return axios.post(`${ip3}/quy-doi/import/excel`, form, {
    params: {
      donViId: payload.donViId,
    },
  });
}
export async function copySchoolQuyDoi(payload: { sourceDonViId: string; targetDonViId: string }) {
  return axios.post(`${ip3}/quy-doi/copy-school`, null, {
    params: payload,
  });
}
export async function getDanhMucThucPhamQuyDoi(payload: {
  page: number;
  limit: number;
  cond?: any;
  donViId?: string;
}) {
  // eslint-disable-next-line no-param-reassign
  if (payload?.donViId === 'Tất cả') delete payload?.donViId;
  return axios.get(`${ip3}/danh-muc-thuc-pham/pageable`, {
    params: payload,
  });
}
